import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { ISearchParam } from "../BaseApp";
import { EmptyUserGroup, IUserGroupModel } from ".";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";

interface IUserGroupsState {
    groups: IUserGroupModel[],
    loading: boolean,
    selectedGroups: IUserGroupModel[],
    searchParams: ISearchParam[],
    pagination: IDataDisplayerPagination,
    search: string
}

const initialState: IUserGroupsState = {
    groups: [],
    loading: false,
    selectedGroups: [],
    searchParams: [],
    search: "",
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const userGroupsSlice = createSlice({
    name: "userGroups",
    initialState,
    reducers: {
        updateAllUserGroups: (state: IUserGroupsState, action: PayloadAction<IUserGroupModel[]>) => {
            state.groups = action.payload
        },
        addNewUserGroup: (state: IUserGroupsState, action: PayloadAction<IUserGroupModel>) => {
            let groups = state.groups

            if (groups.filter(group => group.id === action.payload.id).length === 0){
                state.groups.push(action.payload)
            }

        },
        deleteUserGroup: (state: IUserGroupsState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let groups = state.groups

            groups = groups.filter(group => group.id !== payload.id)

            state.groups = groups

        },
        updateUserGroup: (state: IUserGroupsState, action: PayloadAction<IUserGroupModel>) => {
            let groups = state.groups
            
            if (groups && groups.length > 0){
                groups.map((group) => {
                    if (group.id === action.payload.id){

                        const locationIndex = groups.findIndex(group => group.id === action.payload.id)
                        groups[locationIndex] = action.payload

                    }
                })
            }

            state.groups = groups

        },
        updateUserGroupsLoadingStatus: (state: IUserGroupsState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateUserGroupsPagination: (state: IUserGroupsState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateUserGroupsSearch: (state: IUserGroupsState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        setSelectedUserGroups: (state: IUserGroupsState, action: PayloadAction<IUserGroupModel[]>) => {
            state.selectedGroups = action.payload
        },
        setUserGroupsSearchParams: (state: IUserGroupsState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
    }
})

/**
 * Return all Projects
 */
export const useReturnAllUserGroups = () => useSelector((state: RootState) => state.userGroups.groups)

/**
 * Retrun single brand
 */
export const useReturnSingleUserGroup = (id: number) => {
    const groups = useReturnAllUserGroups()

    let group: IUserGroupModel = EmptyUserGroup

    if (groups.length > 0){
        groups.map((singleGroup) => {
            if (singleGroup.id === id){
                group = singleGroup
            }
        })
    }

    return group

}

/**
 * Return Projects loading status
 */
export const useReturnUserGroupsLoadingStatus = () => useSelector((state: RootState) => state.userGroups.loading)

/**
 * Return Projects pagination
 */
export const useReturnUserGroupsPagination = () => useSelector((state: RootState) => state.userGroups.pagination)

/**
 * Return selected projects
 */
export const useReturnSelectedUserGroups = () => useSelector((state: RootState) => state.userGroups.selectedGroups)

/**
 * Return projects search params
 */
export const useReturnUserGroupsSearchParams = () => useSelector((state: RootState) => state.userGroups.searchParams)

/**
 * Return Projects search
 */
export const useReturnUserGroupsSearch = () => useSelector((state: RootState) => state.userGroups.search)


export const {
    updateAllUserGroups,
    addNewUserGroup,
    deleteUserGroup,
    updateUserGroup,
    updateUserGroupsLoadingStatus,
    updateUserGroupsPagination,
    updateUserGroupsSearch,
    setSelectedUserGroups,
    setUserGroupsSearchParams,
} = userGroupsSlice.actions

export default userGroupsSlice.reducer